import Image from 'next/dist/client/image'
import { useTranslation } from 'hooks/useTranslation'
import { Button } from 'components/Button'
import { Stack } from 'components/Stack'
import { Text } from 'components/Text'
import { PostContent, PostContentType } from '../PostContent'
import { PostImageType } from '../PostImage'
import { PostBannerRoot, ContentWrapper, ImageContainer } from './PostBanner.styles'
import { addParametersToContentfulUrl } from 'utils/addParametersToContentfulUrl'

import * as isologo from '../../../../../../../public/assets/isologo.svg'
import { Link } from 'components/Link'

export type PostBannerType = {
  fields: {
    bannerColor: string
    bannerCta: string
    bannerLink: string
    bannerTitle: string
    bannerText: PostContentType
    bannerImage: PostImageType
  }
}

type PostBannerProps = {
  content: PostBannerType
}

export const PostBanner = ({ content }: PostBannerProps) => {
  const { t } = useTranslation()

  const { bannerColor, bannerCta, bannerLink, bannerTitle, bannerText, bannerImage } =
    content.fields

  return (
    <PostBannerRoot css={{ backgroundColor: bannerColor }}>
      <Stack
        direction={{ '@initial': 'column', '@bp2': 'row' }}
        gap={{ '@initial': '4', '@bp2': '7' }}
        alignItems="center"
      >
        <ImageContainer>
          <img src={addParametersToContentfulUrl(bannerImage.fields.file.url, [{ name: 'fm', value: 'webp' }])} alt={t('blog:ad-alt')} loading="lazy" />
        </ImageContainer>

        <Stack
          alignItems={{ '@initial': 'center', '@bp2': 'flex-start' }}
          direction="column"
          gap={{ '@initial': '4', '@bp2': '5' }}
        >
          <Text align={{ '@initial': 'center', '@bp2': 'left' }}>
            <Stack direction="column" gap={{ '@initial': '2', '@bp2': '3' }}>
              <Text as="h2" size="h1" weight="semiBold">
                {bannerTitle}
              </Text>

              <ContentWrapper>
                <PostContent content={bannerText} />
              </ContentWrapper>
            </Stack>
          </Text>

          <div>
            <Link href={bannerLink} passHref>
              <Button as="a" variant="primary">
                {bannerCta}
              </Button>
            </Link>
          </div>
        </Stack>
      </Stack>
    </PostBannerRoot>
  )
}
